import { t, transforms } from "../utils";
export var interactivity = {
  appearance: true,
  cursor: true,
  resize: true,
  userSelect: true,
  pointerEvents: true,
  outline: {
    transform: transforms.outline
  },
  outlineOffset: true,
  outlineColor: t.colors("outlineColor")
};
//# sourceMappingURL=interactivity.js.map